export const FETCH_JOB_REQUEST = "FETCH_JOB_REQUEST";
export const FETCH_JOB_SUCCESS = "FETCH_JOB_SUCCESS";
export const FETCH_JOB_FAILURE = "FETCH_JOB_FAILURE";

export const UPDATE_FILTER_STATE = "UPDATE_FILTER_STATE";

export const UPDATE_CURRENT_LOCATION_STATE = "UPDATE_CURRENT_LOCATION_STATE";



// WEBPACK FOOTER //
// ./src/global/actionTypes.js